import { SxProps, Theme } from '@mui/system';
import { useState } from 'react';
import { ImageComponent } from './imgLoaderStyles';
import LaundryClothes from '../../logo/laundry-clothes.png';

interface ImgLoaderProps {
  src?: string;
  sx?: SxProps<Theme>;
  alt: string;
  onLoad?: () => void;
  onError?: () => void;
}

export function ImageLoader(props: ImgLoaderProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { sx, alt } = props;

  const onImageLoaded = () => {
    setImageLoaded(true);
    if (props.onLoad) {
      props.onLoad();
    }
  };

  const onImageError = () => {
    setHasError(true);
    setImageLoaded(true);
    if (props.onError) {
      props.onError();
    }
  };

  if (hasError || !props.src) {
    return <ImageComponent sx={sx} src={LaundryClothes} alt={alt} imageLoaded={true} />;
  }

  return (
    <ImageComponent
      sx={sx}
      src={props.src}
      alt={alt}
      imageLoaded={imageLoaded}
      onLoad={onImageLoaded}
      onError={onImageError}
    />
  );
}
